import React from 'react';
import './css/logo.css'

function Logo() {
    return (
      <div className="Logo">
        <header className="Logo-header">
        </header>
      </div>
    );
  }
  
  export default Logo;
